import http from './http';
import {PROJECT_BASE} from './paths';
import {withPerm} from './perm';

const BASE_URL = PROJECT_BASE;

// 프로젝트 도메인 목록 조회
export const getProjectDomainList = withPerm(async (pjtId) => {
  const response = await http.get(`${BASE_URL}/${pjtId}/domain`);
  return response.data;
}, 'GET', `${BASE_URL}/{pjtId}/domain`);

// 프로젝트 도메인 단건 조회
export const getProjectDomain = withPerm(async (pjtId, pjtDomainId) => {
  const response = await http.get(`${BASE_URL}/${pjtId}/domain/${pjtDomainId}`);
  return response.data;
}, 'GET', `${BASE_URL}/{pjtId}/domain/{pjtDomainId}`);

// 프로젝트 도메인 생성
export const createProjectDomain = withPerm(async (pjtId, payload) => {
  const response = await http.post(`${BASE_URL}/${pjtId}/domain`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'POST', `${BASE_URL}/{pjtId}/domain`);

// 프로젝트 도메인 일괄 생성(컨트롤러 사용)
export const createProjectDomainAll = withPerm(async (pjtId, payloadList = []) => {
  const response = await http.post(`${BASE_URL}/${pjtId}/domain/batch`, payloadList, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'POST', `${BASE_URL}/{pjtId}/domain/batch`);

// 프로젝트 도메인 수정
export const updateProjectDomain = withPerm(async (pjtId, pjtDomainId, payload) => {
  const response = await http.patch(`${BASE_URL}/${pjtId}/domain/${pjtDomainId}`, payload, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'PATCH', `${BASE_URL}/{pjtId}/domain/{pjtDomainId}`);

// 프로젝트 도메인 삭제
export const deleteProjectDomain = withPerm(async (pjtId, pjtDomainId) => {
  const response = await http.delete(`${BASE_URL}/${pjtId}/domain/${pjtDomainId}`);
  return response.data;
}, 'DELETE', `${BASE_URL}/{pjtId}/domain/{pjtDomainId}`);

// 해당 프로젝트의 하위 도메인 전체 삭제(컨트롤러 사용)
export const deleteAllProjectDomains = withPerm(async (pjtId) => {
  const response = await http.delete(`${BASE_URL}/${pjtId}/domain/batch`);
  return response.data;
}, 'DELETE', `${BASE_URL}/{pjtId}/domain/batch`); // 경로 오타 수정

// 업서트(존재시 UPDATE, 없으면 INSERT) 배치
export const upsertProjectDomainBatch = withPerm(async (pjtId, payloadList = []) => {
  const response = await http.post(`${BASE_URL}/${pjtId}/domain/upsert-batch`, payloadList, {
    headers: { 'Content-Type': 'application/json' },
  });
  return response.data;
}, 'POST', `${BASE_URL}/{pjtId}/domain/upsert-batch`);

// 헬퍼: 일괄 생성 위임
export const createProjectDomainBatch = async (pjtId, payloadList = []) => {
  return createProjectDomainAll(pjtId, payloadList);
};

// 헬퍼: 선택 삭제는 단건 삭제 병렬 처리 유지
export const deleteProjectDomainBatch = async (pjtId, idList = []) => {
  if (!Array.isArray(idList)) throw new Error('idList must be an array');
  const tasks = idList.map((id) => deleteProjectDomain(pjtId, id));
  return Promise.all(tasks);
};

// 권한 메타 보강: 헬퍼에 _perm 없어서 버튼 비활성화되던 문제 해결
if (!createProjectDomainBatch._perm && createProjectDomainAll?._perm) {
  createProjectDomainBatch._perm = { ...createProjectDomainAll._perm }; // 동일 POST /batch
}
if (!deleteProjectDomainBatch._perm && deleteProjectDomain?._perm) {
  // 개별 삭제 권한과 동일 패턴 사용 (DELETE /domain/{pjtDomainId})
  deleteProjectDomainBatch._perm = { ...deleteProjectDomain._perm };
}
